import { withImageParams } from 'helpers/imageUrl';

/**
 * Artwork for the Offer Portal landing page, exported from Figma (file
 * `Resale`, node 11485-21988) and hosted on imgdrop — the monorepo's hygiene
 * check rejects committed binaries. The photo cards are flat exports of their
 * Figma nodes rather than reassembled layer stacks, so a viewport change
 * cannot knock the laptop screen out of its bezel;
 */
const IMGDROP = 'https://images.opendoor.com/source/s3/imgdrop-production';

// Without a preset the images worker passes the raw export through untouched.
// square-1024 bounds the long edge without cropping (only the 3:2 presets set
// a cropping fit), and the photo exports are ~2x their rendered cards, so
// this is always a downscale.
const photoUrl = (file: string) =>
  withImageParams(`${IMGDROP}/${file}`, { service: 'imgdrop', preset: 'square-1024' });

// No preset: SVGs are vectors, and the hero background is already exported at
// its rendered width, so a square bound would only soften it.
const passthroughUrl = (file: string) =>
  withImageParams(`${IMGDROP}/${file}`, { service: 'imgdrop' });

export const LANDING_MEDIA = {
  heroBackground: {
    src: passthroughUrl('2026-08-1787337339114-06865_background_landing_agent_offer_portal.png'),
  },
  offerDashboard: {
    src: passthroughUrl('2026-08-1786386053056-50379_offer-dashboard.svg'),
    alt: 'A laptop on a kitchen counter showing submitted offers in the Opendoor agent dashboard',
  },
  homeLoans: {
    src: photoUrl('2026-08-1786025650518-52251_home-loans.jpg'),
    alt: 'Two people sitting on a sofa looking at a phone together',
  },
} as const;

export const VALUE_PROP_ICONS = {
  speed: passthroughUrl('2026-08-1786025650520-48124_icon-speed.svg'),
  paperwork: passthroughUrl('2026-08-1786025650520-86535_icon-paperwork.svg'),
  alerts: passthroughUrl('2026-08-1786025650520-71203_icon-alerts.svg'),
} as const;
